export default "__VITE_ASSET__BSf$oEGw__"